<form #photoForm="ngForm" (ngSubmit)="onSubmit()">
  <div class="flex flex-col px-5 py-1 gap-5 max-h-[75vh] overflow-y-auto">
    <div>
      <p-message severity="error" variant="outlined" class="mt-2" [ngClass]="{'hidden': !filesError, 'inline-block': filesError}">
        <span [innerHTML]="filesError"></span>
      </p-message>
      <p-fileupload #filesUpload name="files" [multiple]="true" [showUploadButton]="false" (onSelect)="onFilesSelect($event)" (onUpload)="onFilesUpload($event)" (onClear)="onFilesClear($event)" (onRemove)="onFilesRemove($event)" accept="image/jpeg,image/png,image/webp" maxFileSize="10485760" mode="advanced">
        <ng-template #header let-files let-chooseCallback="chooseCallback" let-clearCallback="clearCallback" let-uploadCallback="uploadCallback">
          <div class="flex flex-wrap justify-between items-center flex-1 gap-4">
            <div class="flex gap-2">
              <p-button (click)="chooseCallback()" icon="pi pi-images" label="Choisir" [outlined]="true" />
              <p-button (click)="uploadPhotos()" icon="pi pi-cloud-upload" label="Envoyer" [outlined]="true" severity="success" [disabled]="!files || files.length === 0" />
              <p-button (click)="clearCallback()" icon="pi pi-times" label="Annuler" [outlined]="true" severity="danger" [disabled]="!files || files.length === 0" />
            </div>
          </div>
        </ng-template>
        <ng-template #empty>
            <div class="flex items-center justify-center flex-col cursor-pointer pt-4" (click)="filesUpload.choose()">
              <i class="pi pi-images !border-2 !rounded-full !p-8 !text-4xl !text-muted-color"></i>
              <p class="!mt-4 !mb-0 text-center">
                Glisser et déposez ici les images d'illustration pour ce produit.<br>
                Images au format <code>JPEG</code> / <code>PNG</code> / <code>WEBP</code> uniquement, taille maximale de 10 Mo.
              </p>
            </div>
        </ng-template>
      </p-fileupload>
    </div>
  </div>
</form>